import type { QueryClient } from '@tanstack/react-query';
import { createRouter, type RouterHistory } from '@tanstack/react-router';
import { LoadingState } from '@lawbee/ui';
import { onboardingRoutes, opsRoutes } from '../pages/app/ops-routes';
import { workRoutes } from '../pages/app/work-routes';
import { portalRoutes } from '../pages/portal/routes';
import { publicRoutes } from '../pages/public/routes';
import { settingsRoutes } from '../pages/settings/routes';
import { appRoute, authedRoute, portalAppRoute, publicRoute, rootRoute } from './parents';

/** Route tree. Page modules export route arrays; this file only assembles them. */
export const routeTree = rootRoute.addChildren([
  publicRoute.addChildren([...publicRoutes]),
  portalAppRoute.addChildren([...portalRoutes]),
  authedRoute.addChildren([...onboardingRoutes, appRoute.addChildren([...opsRoutes, ...workRoutes, ...settingsRoutes])]),
]);

/** `history` defaults to the browser history; tests pass a memory history. */
export function createAppRouter(queryClient: QueryClient, options: { history?: RouterHistory } = {}) {
  return createRouter({
    routeTree,
    ...(options.history ? { history: options.history } : {}),
    context: { queryClient },
    defaultPreload: 'intent',
    defaultPreloadStaleTime: 0,
    scrollRestoration: true,
    defaultPendingComponent: () => <LoadingState />,
  });
}
